import React, { useEffect, useContext, useState } from 'react';
import Highlight from 'react-highlight';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';
import { AppSettings } from './../../config/app-settings.js';

function LayoutCollapsedSidebar() {
	const context = useContext(AppSettings);
	const [code1, setCode1] = useState();
	
	const toggleSidebar = (event) => {
  	event.preventDefault();
  	
  	context.setAppSidebarCollapsed(prevState => !prevState);
  }
	
	useEffect(() => {
		fetch('/quantum-react/assets/data/layout/collapsed-sidebar-code-1.json').then(function(response) { return response.text(); }).then((html) => { setCode1(html); });
		context.setAppSidebarCollapsed(true);
		
		return function cleanUp() {
			context.setAppSidebarCollapsed(false);
		};
		
		// eslint-disable-next-line
	}, []);
	
	return (
		<div>
			<ul className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">LAYOUT</a></li>
				<li className="breadcrumb-item active">COLLAPSED SIDEBAR</li>
			</ul>
			
			<h1 className="page-header">
				Collpased Sidebar <small>page header description goes here...</small>
			</h1>
			
			<Card className="mb-3">
				<CardHeader className="with-btn">
					INSTALLATION
					<CardHeaderBtn />
				</CardHeader>
				<CardBody>
					<p>
						Add the following code for collapsed sidebar page setting.
					</p>
				</CardBody>
				<div className="hljs-container">
					<Highlight className='javascript'>{code1}</Highlight>
				</div>
			</Card>
			<p>
				<a href="#/" onClick={(event) => toggleSidebar(event)} className="btn btn-theme btn-sm">Toggle Sidebar</a>
			</p>
		</div>
	)
}

export default LayoutCollapsedSidebar;